@if (account) {
  <div class="account-detail-container" [ngClass]="{ 'merchant-view': return === 'merchant' }">
    <button type="button" class="back-btn" (click)="onBack()">
      <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg" class="back-icon">
        <path d="M1 1L5.5 5L10 1" stroke="#2A2A2A" stroke-width="1.5" />
      </svg>
      <span>Back to {{ entityLabel }}s</span>
    </button>
    <div class="account-header">
      <div class="account-info">
        <div class="account-avatar">
          @if (account.avatarUrl) {
            <img [src]="account.avatarUrl" [alt]="account.firstName" class="avatar-image" />
          } @else {
            <span class="avatar-initials">{{ account.initials }}</span>
          }
        </div>
        <div class="account-details">
          <div class="account-name-container">
            <h2 class="account-name">{{ account.firstName }}</h2>
            <h2 class="account-name">{{ account.lastName }}</h2>
            <span [class]="'status-badge ' + statusClass">
              {{ account.status }}
            </span>
          </div>
          <p class="account-position">{{ account.position }}</p>
          <p class="account-role">{{ groupNames }}</p>
        </div>
      </div>
    </div>
    <div class="tabs" appTabStrip="Account sections">
      <button
        *appHasPermission="{ resource: Resources.Logs, scope: Scopes.Read }"
        class="tab"
        [ngClass]="{ active: activeTab === 'activity' }"
        (click)="setActiveTab('activity')"
        >
        <mat-icon class="tab-icon">event_note</mat-icon
          ><span class="tab-text" data-text="Activity Log">Activity Log</span>
        </button>
        <!-- Edit Tab -->
        <button
          *appHasPermission="{ resource: permissionResource, scope: Scopes.Update }"
          class="tab"
          [ngClass]="{ active: activeTab === 'edit' }"
          (click)="setActiveTab('edit')"
          >
          <mat-icon class="tab-icon">edit</mat-icon><span class="tab-text" data-text="Edit">Edit</span>
        </button>
      </div>
      @if (activeTab === 'activity') {
        <div class="tab-content">
          <div class="activity-content">
            <div class="activity-header">
              <div class="title-section">
                <div class="inner-tab-title">Activity Log</div>
              </div>
              <div class="filter-buttons">
                <app-pill-dropdown
                  [options]="activityFilterLabels"
                  [selectedOption]="selectedActivityOption"
                  dropdownId="activity"
                  (optionSelected)="onOptionSelected($event)"
                  />
                <app-pill-dropdown
                  [options]="timeFilterLabels"
                  [selectedOption]="selectedTimeOption"
                  dropdownId="time"
                  (optionSelected)="onOptionSelected($event)"
                  />
              </div>
            </div>
            <div class="activity-table">
              @if (activityLoading) {
                <div class="activity-loading">
                  <app-loading-spinner size="large" label="Loading activity..."></app-loading-spinner>
                </div>
              } @else {
                <table>
                  <thead>
                    <tr>
                      <th>Activity</th>
                      <th>Name / Wallet label</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  @if (activityLog.length > 0) {
                    <tbody>
                      @for (activity of activityLog; track activity.id; let last = $last) {
                        <tr [class.no-border]="last">
                          <td>{{ activity.activityType }}</td>
                          <td>{{ activity.entityNameValue || 'N/A' }}</td>
                          <td>{{ formatDateStandard(activity.date) }}</td>
                        </tr>
                      }
                    </tbody>
                  } @else {
                    <tbody>
                      <tr class="no-hover">
                        <td colspan="3">
                          <app-empty-state [filtersApplied]="filtersApplied"></app-empty-state>
                        </td>
                      </tr>
                    </tbody>
                  }
                </table>
                <app-show-more
                  [isShowMore]="hasMoreActivities && !activityLoading && activityLog.length > 0"
                  [isLoading]="isMoreActivityLoading"
                  (loadMore)="loadMoreActivity()"
                  >
                </app-show-more>
              }
            </div>
          </div>
        </div>
      }
      <!-- Edit Tab -->
      @if (activeTab === 'edit') {
        <div class="tab-content edit-tab">
          <div class="edit-content">
            <div class="form-wrapper">
              <h3 class="edit-title">Edit {{ entityLabel }} profile</h3>
              <div class="edit-profile-section">
                <div class="profile-left">
                  <div class="edit-avatar">
                    @if (account.avatarUrl) {
                      <img [src]="account.avatarUrl" [alt]="account.firstName" class="avatar-image" />
                    } @else {
                      @if (photoPreviewUrl) {
                        <img [src]="photoPreviewUrl" [alt]="account.firstName" class="avatar-image" />
                      } @else {
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9 9C11.4853 9 13.5 6.98528 13.5 4.5C13.5 2.01472 11.4853 0 9 0C6.51472 0 4.5 2.01472 4.5 4.5C4.5 6.98528 6.51472 9 9 9Z"
                            fill="#757575"
                            />
                          <path
                            d="M9 10.5C5.68629 10.5 3 13.1863 3 16.5V18H15V16.5C15 13.1863 12.3137 10.5 9 10.5Z"
                            fill="#757575"
                            />
                        </svg>
                      }
                    }
                  </div>
                  <button
                    *appHasPermission="{ resource: permissionResource, scope: Scopes.Update }"
                    type="button"
                    class="change-photo-btn"
                    (click)="openPhotoEditor()"
                    >
                    <img class="edit-icon" [src]="'shared-assets/icons/edit.svg'" alt="Edit icon" />
                    <span>Change profile photo</span>
                  </button>
                </div>
                <div class="profile-actions">
                  @if (account.status === AccountStatus.ACTIVE) {
                    <ng-container *appHasPermission="{ resource: permissionResource, scope: Scopes.Disable }">
                      <app-button
                        buttonVariant="account-status"
                        buttonType="button"
                        [active]="false"
                        [state]="deactivateButtonState"
                        (buttonClick)="onDeactivateAccount()"
                        >
                        <img class="status-icon" src="shared-assets/icons/disable.svg" alt="Disable icon" />
                        <span>Deactivate</span>
                      </app-button>
                    </ng-container>
                  }
                  @if (account.status === AccountStatus.INACTIVE) {
                    <ng-container *appHasPermission="{ resource: permissionResource, scope: Scopes.Enable }">
                      <app-button
                        buttonVariant="account-status"
                        buttonType="button"
                        [active]="true"
                        [state]="deactivateButtonState"
                        (buttonClick)="onDeactivateAccount()"
                        >
                        <span>Activate</span>
                      </app-button>
                    </ng-container>
                  }
                  <div
                    class="security-dropdown"
                    (click)="$event.stopPropagation()"
                *appHasPermission="[
                  { resource: permissionResource, scope: Scopes.ResetPassword },
                  { resource: permissionResource, scope: Scopes.Reset2FA },
                  { resource: permissionResource, scope: Scopes.Reset },
                ]"
                    >
                    <button
                      type="button"
                      class="security-btn"
                      [class.open]="securityDropdownOpen"
                      (click)="toggleSecurityDropdown()"
                      >
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M3 5V3.5C3 2.11929 4.11929 1 5.5 1C6.88071 1 8 2.11929 8 3.5V5M2 5H9C9.55228 5 10 5.44772 10 6V10C10 10.5523 9.55228 11 9 11H2C1.44772 11 1 10.5523 1 10V6C1 5.44772 1.44772 5 2 5Z"
                          stroke="#5F677A"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          />
                      </svg>
                    </button>
                    @if (securityDropdownOpen) {
                      <div class="security-menu">
                        <button
                          type="button"
                          class="security-option"
                          *appHasPermission="{ resource: permissionResource, scope: Scopes.ResetPassword }"
                          (click)="onSecurityAction('reset-password')"
                          >
                          Reset Password
                        </button>
                        <button
                          type="button"
                          class="security-option"
                          *appHasPermission="{ resource: permissionResource, scope: Scopes.Reset2FA }"
                          (click)="onSecurityAction('reset-2fa')"
                          >
                          Reset 2FA
                        </button>
                        <button
                          type="button"
                          class="security-option"
                          *appHasPermission="{ resource: permissionResource, scope: Scopes.Reset }"
                          (click)="onSecurityAction('reset-account')"
                          >
                          Reset {{ entityLabel }}
                        </button>
                      </div>
                    }
                  </div>
                </div>
              </div>
              <form [formGroup]="editForm" (ngSubmit)="onSaveChanges()" class="edit-form">
                <div class="field-group">
                  <app-text-input
                    label="First Name"
                    [isInvalid]="getFieldError('firstName', 'First name') !== ''"
                [errorMessage]="
                  getFieldError('firstName', 'First name', {
                    invalidText:
                      'First name should start with a letter and can contain letters, spaces, periods, apostrophes, hyphens, and dashes.',
                  })
                "
                    formControlName="firstName"
                    >
                  </app-text-input>
                </div>
                <div class="field-group">
                  <app-text-input
                    label="Last Name"
                    [isInvalid]="getFieldError('lastName', 'Last name') !== ''"
                [errorMessage]="
                  getFieldError('lastName', 'Last name', {
                    invalidText:
                      'Last name should start with a letter and can contain letters, spaces, periods, apostrophes, hyphens, and dashes.',
                  })
                "
                    formControlName="lastName"
                    />
                </div>
                <!-- Position Field -->
                <div class="field-group">
                  <app-text-input
                    label="Company Position"
                    [isInvalid]="getFieldError('position', 'Company position') !== ''"
                    [errorMessage]="getFieldError('position', 'Company position')"
                    formControlName="position"
                    />
                </div>
                <div class="field-group">
                  <app-text-input
                    label="Email"
                    [isInvalid]="getFieldError('email', 'Email') !== ''"
                    [errorMessage]="getFieldError('email', 'Email')"
                    [showCopyIcon]="true"
                    [disable]="true"
                    formControlName="email"
                    >
                    <div icon>
                      <div class="email-indicator"></div>
                    </div>
                  </app-text-input>
                </div>
                <div class="field-group">
                  <app-dropdown
                    label="Role"
                    placeholder="Select Role"
                    [options]="roleOptions"
                    formControlName="role"
                    [isInvalid]="getFieldError('role', 'Role') !== ''"
                    [type]="'checkbox'"
                    [errorMessage]="getFieldError('role', 'Role')"
                    />
                </div>
                <div class="form-actions" *appHasPermission="{ resource: permissionResource, scope: Scopes.Update }">
                  <app-button
                    buttonVariant="detail-secondary"
                    buttonType="button"
                    [state]="cancelEditButtonState"
                    (buttonClick)="onCancelEdit()"
                    >
                    Cancel
                  </app-button>
                  <app-button buttonVariant="detail-primary" buttonType="submit" [state]="submitEditButtonState">
                    Submit
                  </app-button>
                </div>
              </form>
              @if (loading) {
                <app-loading-spinner size="large" [isOverlay]="true"></app-loading-spinner>
              }
            </div>
          </div>
        </div>
      }
    </div>
  }

  @if (!account && loading) {
    <div class="loading-container">
      <app-loading-spinner size="large" [label]="`Loading ${entityLabel} details`"></app-loading-spinner>
    </div>
  }

  @if (!account && !loading) {
    <div class="error-container">
      <h3>{{ entityLabel }} Not Found</h3>
      <p>The requested {{ entityLabel }} could not be found.</p>
      <app-button buttonVariant="detail-primary" buttonType="button" (buttonClick)="onBack()">Back to {{ entityLabel }}s</app-button>
    </div>
  }

  @if (showConfirm) {
    <div class="confirm-overlay">
      <div class="confirm-dialog">
        <p class="confirm-message">{{ confirmMessage }}</p>
        <div class="confirm-actions">
          <app-button buttonVariant="detail-secondary" buttonType="button" (buttonClick)="onCancel()">No</app-button>
          <app-button buttonVariant="detail-primary" buttonType="button" (buttonClick)="onConfirm()">Yes</app-button>
        </div>
      </div>
    </div>
  }
